import React from "react";
import { Shield } from "lucide-react";

export const AdminLoadingState: React.FC = () => {
  return (
    <main className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex items-center gap-3 text-muted-foreground">
        <Shield className="h-5 w-5 animate-pulse text-primary" />
        <span className="text-sm font-medium">Verifying admin access…</span>
      </div>
    </main>
  );
};
